<template>
  <div>
    <WCFormGroup :field="$v.email">
      <!-- For each email on boarding profile -->
      <WCLabel :for="'email' + emails.did">{{ emails.name }}</WCLabel>
      <WCInput
        autocomplete="email"
        class="form-control email-input bg-light"
        :id="'email' + emails.did"
        :value="emails.email.value"
        @input="change()"
      />
      <WCValidationErrors />
    </WCFormGroup>
  </div>
</template>
<script>
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import { email, required } from 'vuelidate/lib/validators';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import { ACCOUNT_SETTINGS_OPTIONS } from '@/constants/AppConstants';

export default {
  name: 'WCAccountSettingsEmailInput',
  components: { WCFormGroup, WCInput, WCValidationErrors, WCLabel },
  props: {
    emails: {
      type: Object,
    },
    did: {
      type: String,
    },
  },
  data() {
    return {
      email: this.emails && this.emails.email.value,
    };
  },
  mounted() {
    this.$emit('update:valid', !this.$v.$invalid, this.did);
  },
  validations() {
    return {
      email:
        this.emails && this.emails.email.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
          ? { email, required }
          : { email },
    };
  },

  methods: {
    change() {
      const emailObject = { ...this.emails, email: { value: this.email } };
      this.$emit('input', emailObject);
      this.$emit('update:valid', !this.$v.$invalid, this.did);
    },
  },
};
</script>
